'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagHnAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M-9.53674e-05 0C9.33324 0.000119906 18.6666 1.15037e-05 27.9999 1.15037e-05C27.9999 6.66668 27.9999 13.3333 27.9999 20C18.6666 20 9.33332 20 2.67029e-05 20L-9.53674e-05 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M-9.53674e-05 6.66668H27.9999V1.15037e-05L-9.53674e-05 0V6.66668Z",
          fill: "#0884E6"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.67029e-05 20H27.9999V13.3333H-9.53674e-05L2.67029e-05 20Z",
          fill: "#0884E6"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.9999 10.6667L13.0571 10.9428L13.3332 10L13.0571 9.0572L13.9999 9.33335L14.9427 9.0572L14.6666 10L14.9427 10.9428L13.9999 10.6667Z",
          fill: "#0E88E9"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.3332 9.33335L18.3904 9.60949L18.6666 8.66668L18.3904 7.72387L19.3332 8.00001L20.276 7.72387L19.9999 8.66668L20.276 9.60949L19.3332 9.33335Z",
          fill: "#0E88E9"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.3332 12L18.3904 12.2762L18.6666 11.3333L18.3904 10.3905L19.3332 10.6667L20.276 10.3905L19.9999 11.3333L20.276 12.2762L19.3332 12Z",
          fill: "#0E88E9"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.66657 12L7.72376 12.2762L7.9999 11.3333L7.72376 10.3905L8.66657 10.6667L9.60938 10.3905L9.33324 11.3333L9.60938 12.2762L8.66657 12Z",
          fill: "#0E88E9"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.66657 9.33335L7.72376 9.60949L7.9999 8.66668L7.72376 7.72387L8.66657 8.00001L9.60938 7.72387L9.33324 8.66668L9.60938 9.60949L8.66657 9.33335Z",
          fill: "#0E88E9"
        }
      )
    ]
  }
);
const VpFlagHnAsset = forwardRef(FlagHnAsset);

export { VpFlagHnAsset as default };
